module.exports = __webpack_public_path__ + "static/media/member-emblem-aqua.5c5a2bf5.png";